import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5b2af62e&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=5b2af62e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2af62e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2af62e')) {
      api.createRecord('5b2af62e', component.options)
    } else {
      api.reload('5b2af62e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=5b2af62e&scoped=true&", function () {
      api.rerender('5b2af62e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/social/detail.vue"
export default component.exports